import { useState } from "react";
import { getTrackingDetails } from "../services/productionService";

const useProductionTracking = () => {
    const [productionTracking, setProductionTracking] = useState([]);
    const [dataloading, setdataLoading] = useState(false);

    // Fetch sales order numbers
    const fetchRequestIndentNumber = async (mode, so_numebr, cr_number) => {
        const para = {
            p_companyid: localStorage.getItem("companyid"),
            p_plant_id: 1,
            p_so_number: so_numebr,
            p_cr_number: cr_number,
            p_mode: mode,
        };
        setdataLoading(true); // Show loader
        try {
            const data = await getTrackingDetails(para);
            if (data && data.length > 0) {
                setProductionTracking(data);
            }
        } catch (error) {
            console.error("Error fetching sales order numbers:", error);
        }
        finally {
            setdataLoading(false); // Hide loader after fetching
        }
    };

    // Function to update selected sales order number
    const loadProductionTrackingBySOAndCRNumber = async (mode, so_numebr, cr_number) => {
        await fetchRequestIndentNumber(mode, so_numebr, cr_number);
    };

    return { productionTracking, dataloading, setProductionTracking, setdataLoading, loadProductionTrackingBySOAndCRNumber };
};

export default useProductionTracking;
